module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-05.030ef126.png";